<template>
  <form-item v-bind="$attrs" v-on="$listeners" class-name="Date">
    <el-date-picker class="fullwidth"
                    v-model="model[$attrs.prop]"
                    type="date"
                    format="yyyy-MM-dd">
    </el-date-picker>
  </form-item>
</template>

<script>
  import FormItem from '@/components/form/FormItem'

  export default {
    name: 'DateFormItem',
    components: { FormItem },
    computed: {
      model () {
        let parent = this.$parent
        while (parent) {
          if (parent.model != null) return parent.model
          parent = parent.$parent
        }
        return null
      }
    }
  }
</script>
